import React, { useMemo } from 'react';

const QuoteCustomerLoaderRow = ({ headCells, actionColumnWidthClass }: any) => {
    const tableCells = useMemo(
        () => [
            {
                key: 'code',
                htmlDynamic: (
                    <td className="max-w-px min-w-[190px]">
                        <span className="custom-loading truncate">Lorem Ipsum </span>
                    </td>
                ),
            },
            {
                key: 'userData',
                htmlDynamic: (
                    <td className="max-w-px min-w-[155px]">
                        <span className="custom-loading truncate">Lorem Ipsum dolor</span>
                    </td>
                ),
            },
            {
                key: 'status',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[125px]">
                        <span className="custom-loading">Lorem ipsum</span>
                    </td>
                ),
            },
            {
                key: 'classification',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[115px]">
                        <span className="custom-loading rounded-md">Lorem ip</span>
                    </td>
                ),
            },
            {
                key: 'division',
                htmlDynamic: (
                    <td className="max-w-px min-w-[150px]">
                        <span className="custom-loading truncate">Lorem Ipsum</span>
                    </td>
                ),
            },
            {
                key: 'customerBillingAccount',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[125px]">
                        <span className="custom-loading">Lorem</span>
                    </td>
                ),
            },
            {
                key: 'shipperFullAddress',
                htmlDynamic: (
                    <td className="max-w-px min-w-[150px]">
                        <span className="custom-loading">Lorem Ipsum</span>
                    </td>
                ),
            },
            {
                key: 'consigneeFullAddress',
                htmlDynamic: (
                    <td className="max-w-px min-w-[150px]">
                        <span className="custom-loading">Lorem Ipsum</span>
                    </td>
                ),
            },
            {
                key: 'stopsCount',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[110px]">
                        <span className="custom-loading">Lorem</span>
                    </td>
                ),
            },
            {
                key: 'updatedAt',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[145px]">
                        <span className="custom-loading">Lorem Ipsum lorem</span>
                    </td>
                ),
            },
            {
                key: 'createdAt',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[175px]">
                        <span className="custom-loading">Lorem Ipsum lorem</span>
                    </td>
                ),
            },
            {
                key: 'pickupDate',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[175px]">
                        <span className="custom-loading">Lorem Ipsum lorem</span>
                    </td>
                ),
            },
            {
                key: 'totalUnits',
                htmlDynamic: (
                    <td className="max-w-px min-w-[135px]">
                        <span className="custom-loading">Lorem Ipsum</span>
                    </td>
                ),
            },
            {
                key: 'totalWeight',
                htmlDynamic: (
                    <td className="max-w-[6.95%] min-w-[135px]">
                        <span className="custom-loading">Lorem Ipsum</span>
                    </td>
                ),
            },
            {
                key: 'action',
                htmlDynamic: (
                    <td className="w-[98px] max-w-[98px] table-cell-with-tooltip">
                        <div className={`flex items-center justify-end gap-2 h-full table-col-tooltip-space-common-xs ml-auto ${actionColumnWidthClass || ''}`}>
                            <span className="custom-loading block w-4 h-4 rounded" />
                        </div>
                    </td>
                ),
            },
        ],
        [headCells, actionColumnWidthClass]
    );

    return (
        <>
            {headCells
                ?.filter((cell: any) => cell.visible)
                .map((cell: any) => {
                    if (cell.id === 'checkbox') {
                        return (
                            <React.Fragment key="checkbox">
                                <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip">
                                    <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                                        <div className="custom-loading w-4 h-4 rounded flex-none" />
                                    </div>
                                </td>
                            </React.Fragment>
                        );
                    }

                    const matched = tableCells.find((tCell) => tCell.key === cell.id);

                    if (!matched) return null;

                    return <React.Fragment key={cell.id}>{matched.htmlDynamic}</React.Fragment>;
                })}
        </>
    );
};

export default QuoteCustomerLoaderRow;
